// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hdcK","colMin":"styles_colMin__2WcIs"};